import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TmcAuthFrameComponent } from './tmc-auth-frame/tmc-auth-frame.component';

const routes: Routes = [
  { path: '', component: TmcAuthFrameComponent },
  { path: '**', component: TmcAuthFrameComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
